












































import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';
import PointTable from './pointTable.vue';
import PointFilter from './pointFilter.vue';
import DetailPoint from './detailPoint.vue';
import pointDetailOption from '../testMock/pointDetail';
import { ChildType } from '../types/interface';
export default Vue.extend({
    components: {
        PointTable,
        PointFilter,
        DetailPoint,
    },
    data() {
        return {
            statistics: ChildType.Statistics,
            engineValue: ChildType.EngineValue,

            checkPointList: [],
            // value是测点的资源id
            pointListOptions: [{
                value: 'cedian1',
                label: '测点1',
                childValueTyle: 1,
                aggregate: '',
                period: '',
                periodAggregate: '',
            }, {
                value: 'cedian2',
                label: '测点2',
                childValueTyle: 1,
                aggregate: '',
                period: '',
                periodAggregate: '',
            },{
                value: 'cedian3',
                label: '测点3',
                childValueTyle: 1,
                aggregate: '',
                period: '',
                periodAggregate: '',
            },{
                value: 'cedian4',
                label: '测点4',
                childValueTyle: 1,
                aggregate: '',
                period: '',
                periodAggregate: '',
            },{
                value: 'cedian5',
                label: '测点5',
                childValueTyle: 1,
                aggregate: '',
                period: '',
                periodAggregate: '',
            },{
                value: 'cedian6',
                label: '测点6',
                childValueTyle: 1,
                aggregate: '',
                period: '',
                periodAggregate: '',
            }],
            pointCheckOptions: [],

            // 测点详情的配置项
            pointDetailOption: pointDetailOption,

            dialogVisible: false,
            currentPont: {
                childValueTyle: 1,
                aggregate: '',
                period: '',
                periodAggregate: '',
            },
            
            pointDetail: {
                // 取值类型 - 统计值和工程值
                childValueTyle: 1,
                // 历史值 - 周期
                period: '',
                // 历史值 - 和聚合
                aggregate: '',
                // 聚合周期 - 统计值
                periodAggregate: '',
            },
            
            // 是否在编辑测点
            isEditPoint: false,
            // 是否为测点操作状态，主要是解决改变测点事件发生在测点数据改变之前的问题...
            pointGroupPadding: false,
        };
    },
    computed: {
        ...mapState({
            partSelection: (state: any) => state.screen.editor.partSelection
        }),
        /**
         * 被选中的part数组
         */
        selectGroup(): Model.Part[] {
            return this.partSelection.selectGroup
        },
        /**
         * 当前选中的part
         * 目前只处理单个part
         */
        curSelectPart(): Model.Part {
            const { length } = this.selectGroup
            return length === 1 && this.isReleasePart ? this.selectGroup[0] : {}
        },
        /**
         * 优化选中part的性能
         * 修改为释放part，才更新配置项 -- 样式 or 数据
         */
        isReleasePart(): boolean {
            return this.partSelection.releasePart;
        },
        partData(): any {
            const partData = this.curSelectPart.partData;
            return partData;
        },
        pointData(): any {
            const pointData =  (this.partData && this.partData.pointData) || {};
            return pointData;
        },
        pointGroup(): any[] {
            return (this.pointData && this.pointData.pointGroup) || [];
        }
    },
    watch: {
        curSelectPart(part: Model.Element) {
            if (!this.isReleasePart) {
                return
            }
            this.initPointCheckOptions();
        },
    },
    methods: {
        ...mapMutations([
            'set_partData',
        ]),
        /**
         * 初始化代理测点
         */
        initPointDetail() {
            this.pointDetail.childValueTyle = 1;
            this.pointDetail.periodAggregate = '';
            this.pointDetail.aggregate = '';
            this.pointDetail.period = '';
        },
        /**
         * 新增选中测点
         * 有可能是编辑
         * 有可能是新增
         */
        addCheckPoint() {
            // 模型值映射
            this.modalMapToCurrentPoint();

            // 校验添加的是否有空配置项
            if (this.validateNullPoint()) {
                return;
            }

            //是否存在相同配置的测点
            if (this.validateSamePoint()) {
                this.$message.error('存在相同的测点配置');
                return;
            }

            // 隐藏模态框
            this.dialogVisible = false;

            if (this.isEditPoint) {
                const index: number  = this.pointCheckOptions.findIndex( (item) => {
                    // 根据测点的id判断
                    return this.currentPont.id === item.id;
                });

                index !== -1 && this.pointCheckOptions.splice(index, 1 , this.currentPont);
                this.isEditPoint = false;
            } else {
                const copyCurPoint = _.cloneDeep(this.currentPont);
                const checkPointId = _.uniqueId('point_');
                Object.assign(copyCurPoint, {id: checkPointId});

                this.pointCheckOptions.push( copyCurPoint );
            }

            // 更新测点详情模型数据，并请求测点数据
            this.emitFetchPointData();
        },
        modalMapToCurrentPoint(): void {
            this.currentPont.childValueTyle = this.pointDetail.childValueTyle;
            this.currentPont.periodAggregate = this.pointDetail.periodAggregate;
            this.currentPont.aggregate = this.pointDetail.aggregate;
            this.currentPont.period = this.pointDetail.period;
        },
        /**
         * 校验测点配置是否有未配置的选项
         */
        validateNullPoint(): boolean {
            console.log(this.currentPont);
            
            if (!this.currentPont.childValueTyle) {
                this.$message.error('测点类型不能为空');
                return true;
            }
            if (this.currentPont.childValueTyle === this.statistics) {
                if (!this.currentPont.periodAggregate) {
                    this.$message.error('周期聚合不能为空');
                    return true;
                }
            }
            if (this.currentPont.childValueTyle === this.engineValue) {
                if (!this.currentPont.aggregate) {
                    this.$message.error('取值聚合不能为空');
                    return true;
                }
                if (!this.currentPont.period) {
                    this.$message.error('取值周期不能为空');
                    return true;
                }
            }
            return false;
        },
        /**
         * 检验是否有相同的测点
         */
        validateSamePoint(): boolean {
             // 检测是否存在相同的配置
            const isSamePoint = this.pointCheckOptions.some( (checkPoint: any) => {
                // value为测点id
                if (checkPoint.value !== this.currentPont.value) {
                    return false;
                }
                // 工程值比较是否相同
                if (this.currentPont.childValueTyle && this.currentPont.childValueTyle === this.statistics) {
                    if (this.currentPont.periodAggregate === checkPoint.periodAggregate) {
                        return true;
                    }
                // 统计值比较是否相同;
                } else if (this.currentPont.childValueTyle && this.currentPont.childValueTyle === this.engineValue) {
                    if (this.currentPont.aggregate === checkPoint.aggregate 
                    && this.currentPont.period === checkPoint.period) {
                        return true;
                    }
                }
            });
            return isSamePoint;
        },
        /**
         * 新增测点
         * 得到选中的测点
         */
        getCheckPoint(point: any) {
            // 测点详情弹框
            this.dialogVisible = true;
            this.initPointDetail();
            this.currentPont = _.cloneDeep(point);
        },
        deleCheckPoint(point: any) {
            const index: number  = this.pointCheckOptions.findIndex( (item) => {
                // 根据测点的id判断
                return point.id === item.id;
            });

            index !== -1 && this.pointCheckOptions.splice(index, 1);

            // 更新测点详情模型数据，并请求测点数据
            this.emitFetchPointData();
        },
        editCheckPoint(point: any) {
            this.isEditPoint = true;
            this.dialogVisible = true;
            this.currentPont = _.cloneDeep(point);
            
            this.pointDetail.childValueTyle = this.currentPont.childValueTyle;
            this.pointDetail.periodAggregate = this.currentPont.periodAggregate;
            this.pointDetail.aggregate = this.currentPont.aggregate;
            this.pointDetail.period = this.currentPont.period;
        },
        initPointCheckOptions() {
            if (this.pointGroup) {
                // 反映射
                this.pointCheckOptions =  this.pointGroup.map( (item) => {
                    return {
                        value: item.pointId,
                        label: item.pointName,
                        aggregate: item.aggregate,
                        period: item.period,
                        childValueTyle: item.childValueTyle,
                        periodAggregate: item.periodAggregate,
                        id: _.uniqueId('point_'),
                    }
                });
            }
            this.resetPointListOptions();
        },
        // 这里应该是重新获取数据或是重置数据
        resetPointListOptions() {
            for (const point of this.pointListOptions) {
                point.disable = false;
            }
        },
        // 切换测点详情弹出框的状态
        handleDialogVisible(toggle: boolean): void {
            this.dialogVisible = toggle;
        },
        // 实时编辑测点
        editPointDetail(key: string, value: string): void {
            (this.pointDetail as any)[key] = value;
        },
        /**
         * 更新测点数据
         */
        updatePointGroup() {
            const pointGroup =  this.pointCheckOptions.map( (item) => {
                return {
                    pointId: item.value,
                    pointName: item.label,

                    childValueTyle: item.childValueTyle,
                    periodAggregate: item.periodAggregate,
                    period: item.period,
                    aggregate: item.aggregate,
                }
            });
            const option = {
                pointGroup: pointGroup,
                mode: 'pointData',
            };
            this.set_partData(option);
        },
        /**
         * 通知展示数据获取测点数据
         * 触发事件，测点的增加，删除，更改
         */
        emitFetchPointData() {
            this.updatePointGroup();
            (this.$root as any).busRef.$emit('fetchPoint')
        },
    },
    created() {
        this.initPointCheckOptions();
    },
    mounted() {
        // console.log("point mounted");
    }
})
